import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function Imaging({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();
  const wikiLink = singleSubjectId
    ? "/wiki/guides/exploration-singlesubject-imaging"
    : "/wiki/guides/exploration-measures-imaging";

  return (
    <PageTemplate
      title="Measures: Imaging"
      tooltipText="Explore imaging data, create data subsets, view visualizations, and download data and visualizations."
      type="imaging"
      constants={{
        wikiLink,
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/imaging`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
